<template>
  <div class="managingPeople hp100 bbox" v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <div class="flex align-center justify-start header-search-box">
          <el-input
            placeholder="请输入会员卡号"
            clearable
            v-model="searchInput"
            class="header-search-input ml10 mt10"
            style="width: 140px"
          >
          </el-input>
        </div>
        <el-select
        style="width: 120px"
          v-model="departmentCode"
          placeholder="请选择部门"
          clearable
          class="ml10 mt10"
        >
          <el-option
            v-for="item in departmentOptions"
            :key="item.departmentCode"
            :label="item.departmentName"
            :value="item.departmentCode"
          >
          </el-option>
        </el-select>
        <el-select
        style="width: 120px"
          v-model="levelCode"
          placeholder="请选择等级"
          clearable
          class="ml10 mt10"
        >
          <el-option
            v-for="item in memberLevelOptions"
            :key="item.id"
            :label="item.levelName"
            :value="item.levelCode"
          >
          </el-option>
        </el-select>
        <el-select
        style="width: 120px"
          v-model="businessCode"
          placeholder="请选择门店"
          clearable
          class="ml10 mt10"
        >
          <el-option
            v-for="item in merchantListOptions"
            :key="item.merchantCode"
            :label="item.merchantName"
            :value="item.merchantCode"
          >
          </el-option>
        </el-select>
        <el-button
          style="background: #f59a23; color: #fff; border-color: #f59a23"
          @click="search()"
          class="ml10 mt10"
          >搜索</el-button
        >
        <el-button
          style="background: #f59a23; color: #fff; border-color: #f59a23"
          class="ml10 mt10"
        >
          <a
            href="https://pos.pluss.cn/resources/sdk/%E4%BC%9A%E5%91%98%E5%AF%BC%E5%85%A5%E6%A8%A1%E7%89%88.xlsx"
          >
            模板下载
          </a>
        </el-button>
        <el-upload
          class="upload-demo ml10 mt10"
          :action="$uploadURL"
          :on-preview="handlePreview"
          :on-remove="handleRemove"
          :limit="1"
          accept=".xlsx .xls"
          :on-exceed="handleExceed"
          :on-success="handleSuccess"
          :file-list="fileList"
        >
          <el-button
            style="background: #f59a23; color: #fff; border-color: #f59a23"
            class="ml10"
            >会员导入</el-button
          >
        </el-upload>
        <el-button
          style="background: #f59a23; color: #fff; border-color: #f59a23"
          class="ml10 mt10"
          >会员总余额: {{ totalRemaing }}</el-button
        >
      </el-row>
   <!-- 储值区域 -->
   <div class="mainInfo">
       <div class="titleInfo">储值信息 </div>
       <div class="itemInfo">
                  <div class="item">
          <div class="top">
            <div class="title">储值金额_历史累计(元)</div>
            <div class="num">0.00</div>
          </div>
          <div class="bottom">
            <div class="bottomItem">
              <div class="title">本金（元）</div>
              <div class="num">0.00</div>
            </div>
            <div class="bottomItem">
              <div class="title">赠金（元）</div>
               <div class="num">0.00</div>
            </div>
             
          </div>
        </div>
                <div class="item">
          <div class="top">
            <div class="title">储值金额(元)</div>
            <div class="num">0.00</div>
          </div>
          <div class="bottom">
            <div class="bottomItem">
              <div class="title">本金（元）</div>
              <div class="num">0.00</div>
            </div>
            <div class="bottomItem">
              <div class="title">赠金（元）</div>
               <div class="num">0.00</div>
            </div>
             
          </div>
        </div>
       </div>
   </div>

      <!-- 用户列表区域 -->
      <div >

            <el-table
            height="calc(100vh - 388px)"
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
              ></el-table-column>

              <el-table-column
                label="创建日期(发卡日期)"
                align="center"
                prop="创建日期"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column label="手机号码" align="center" prop="手机号码">
                <template slot-scope="scope">
                  <span>{{ scope.row.phone }}</span>
                </template>
              </el-table-column>
              <el-table-column label="会员卡号" align="center" prop="会员卡号">
                <template slot-scope="scope">
                  <span>{{ scope.row.memberCardID }}</span>
                </template>
              </el-table-column>
              <el-table-column label="用户名" align="center" prop="用户名">
                <template slot-scope="scope">
                  <span>{{ scope.row.userName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="剩余金额" align="center" prop="剩余金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.remaining }}</span>
                </template>
              </el-table-column>
              <el-table-column label="补贴金额" align="center" prop="剩余金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.subsidyAmount || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="可用积分" align="center" prop="剩余积分">
                <template slot-scope="scope">
                  <span>{{ scope.row.usableScore || 0 }}</span>
                </template>
              </el-table-column>
              <el-table-column label="卡类型" align="center" prop="剩余积分">
                <template slot-scope="scope">
                  <span>{{ scope.row.cardTypeName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="剩余次数" align="center" prop="剩余积分">
                <template slot-scope="scope">
                  <span>{{ scope.row.remainingTimes }}</span>
                </template>
              </el-table-column>
              <el-table-column label="到期时间" align="center" prop="剩余积分">
                <template slot-scope="scope">
                  <span>{{ scope.row.limitDt | dataFormat }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <span
                    style="color: #f59a23; cursor: pointer"
                    @click="getDetail(scope.row.id, scope.row.userCode)"
                  >
                    卡操作
                  </span>
                </template>
              </el-table-column>
            </el-table>
      </div>
      <div class="footerBo">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
    <el-dialog title="卡操作" :visible.sync="dialogVisible" width="50%">
      <el-form
        :model="merchantMember"
        ref="merchantMember"
        label-width="150px"
        class="merchantMember"
      >
        <el-form-item label="剩余金额" prop="remaining">
          <el-input style="width:220px" v-model="merchantMember.remaining"></el-input>
        </el-form-item>
        <el-form-item label="积分" prop="usableScore">
          <el-input style="width:220px" v-model="merchantMember.usableScore"></el-input>
        </el-form-item>

        <el-form-item label="是否发送短信" prop="isSms">
          <!-- <el-input v-model="merchantMember.isSms"></el-input> -->
          <el-select style="width:220px" v-model="merchantMember.isSms" placeholder="请选择">
            <el-option
              v-for="item in smsOption"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否积分" prop="isScroll">
          <!-- <el-input v-model="merchantMember.isScroll"></el-input> -->
          <el-select style="width:220px" v-model="merchantMember.isScroll" placeholder="请选择">
            <el-option
              v-for="item in scrollOption"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="卡类型" prop="cardTypeCode">
          <!-- <el-input v-model="merchantMember.isSms"></el-input> -->
          <el-select style="width:220px" v-model="merchantMember.cardTypeCode" placeholder="请选择">
            <el-option
              v-for="item in cardTypeOption"
              :label="item.label"
              :value="item.value"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="到期时间" prop="limitDt">
          <el-date-picker
            v-model="merchantMember.limitDt"
            type="datetime"
            placeholder="选择日期时间"
            default-time="23:59:59"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="剩余次数" prop="remainingTimes">
          <el-input style="width:220px" v-model="merchantMember.remainingTimes"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button   style="background: #f59a23; color: #fff; border-color: #f59a23" @click="submitForm('merchantMember')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      totals:0,
      id:"",
              smsOption: [{
          value: 0,
          label: "否",
        }, {
          value: 1,
          label: "是",
        }
        ],
        scrollOption: [{
          value: 0,
          label: "否",
        }, {
          value: 1,
          label: "是",
        }],
        cardTypeOption: [{
          value: "storeCard",
          label: "储值卡",
        }, {
          value: "timesCard",
          label: "次卡",
        }, {
          value: "durationCard",
          label: "时长卡",
        }
        ],
              scrollOption: [{
          value: 0,
          label: "否",
        }, {
          value: 1,
          label: "是",
        }],
        cardTypeOption: [{
          value: "storeCard",
          label: "储值卡",
        }, {
          value: "timesCard",
          label: "次卡",
        }, {
          value: "durationCard",
          label: "时长卡",
        }
        ],
              cardTypeOption: [{
          value: "storeCard",
          label: "储值卡",
        }, {
          value: "timesCard",
          label: "次卡",
        }, {
          value: "durationCard",
          label: "时长卡",
        }
        ],
              merchantMember: {
            id:"",
            merchantCode:"",
            merchantName:"",
            userCode:"",
            loginName:"",
            nickName:"",
            userName:"",
            status:"",
            userType:"",
            phone:"",
            sex:"",
            logo:"",
            openId:"",
            usableScore:"",
            totalScore:"",
            remaining:"",
            levelCode:"",
            levelName:"",
            memberCardID:"",
            createDt:"",
            sourceCode:"",
            sourceName:"",
            creatorCode:"",
            creatorName:"",
            remark:"",
            labels:"",
            groupCode:"",
            groupName:"",
            discount:"",
            usedDiscountAmount:"",
            discountAmount:"",
            departmentName:"",
            departmentCode:"",
            birthDt: "",
            isScroll: 0,
            isSms:0,
        },
      //
      dialogVisible: false,
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: "",
        },
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: "",
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      //会员总余额
      totalRemaing: 0,
      departmentOptions: [],
      memberLevelOptions: [],
      merchantListOptions: [],
      levelCode: "",
      userCode: "",
      departmentCode: "",
      businessCode: "",
      fileList: [],
      uploadURL: "http://127.0.0.1:8001/api/upload/uploadFile",
      dialogImport: false,
    };
  },
  created() {
    // this.queryInfo.currPage = this.$route.query.currPage;
    // this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
    this.getMemberLevelList();
    this.getMerchantList();
    this.getDepartmentList();
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
     async submitForm(formName){
        var cardTypeCode=this.merchantMember.cardTypeCode;
        for(var i=0;i<this.cardTypeOption.length;i++){
            var cardType=this.cardTypeOption[i];
            if(cardTypeCode==cardType.value){
                this.merchantMember.cardTypeName=cardType.label;
            }
        }
         console.log("参数-----",this.merchantMember)
        let res=await this.$http.post("/merchantMemberCards/save", this.merchantMember)
        if(res.data.code==200){
            this.$notify.success({
            title: "提示",
            message: "保存成功",
            showClose: true,
          });
          this.search()
          this.dialogVisible=false
        }else{
          this.$message.error(res.data.message)
        }
    },
   async loadBaseInfo(){
      if(this.id!=undefined&&this.id!=''){
        let res=await this.$http.post("/merchantMemberCards/queryOne", {id:this.id})
          if (res.data.code == 200) {
            this.totals = res.data.data.count;
            this.merchantMember = res.data.data;
          }else{
         ths.$message.error(res.data.message)
          }

      }

    },
    //条件查询
    search() {
      this.queryInfo.condition.userCode = this.searchInput;
      this.queryInfo.condition.departmentCode = this.departmentCode;
      this.queryInfo.condition.levelCode = this.levelCode;
      this.queryInfo.condition.businessCode = this.businessCode;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    getDetail(id) {
      this.id=id
      this.dialogVisible=true
      this.loadBaseInfo()
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).catch((err) => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantMemberCards/delete", { id: id })
          .then(function (response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true,
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;

      that.queryInfo.condition.merchantCode =
        localStorage.getItem("merchantCode");
      that.$http
        .post(
          "/merchantMembers/queryMerchantMemberByConditions",
          that.queryInfo
        )
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.pager.count;
            that.queryInfo.currPage = response.data.data.pager.currPage;
            that.tableData = response.data.data.pager.data;
            that.totalRemaing = response.data.data.totalRemaing;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    //查询用户等级
    getMemberLevelList() {
      var that = this;

      let merchantCode = localStorage.getItem("merchantCode");
      that.$http
        .post("/select/queryMemberLevelList", { merchantCode })
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.memberLevelOptions = response.data.data;
          }
        });
    },
    //查询商家列表
    getMerchantList() {
      var that = this;
      let merchantCode = localStorage.getItem("merchantCode");
      that.$http
        .post("/select/queryMerchantList", { merchantCode })
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.merchantListOptions = response.data.data;
          }
        });
    },
    //查询部门列表
    getDepartmentList() {
      var that = this;
      let merchantCode = localStorage.getItem("merchantCode");
      that.$http
        .post("/select/queryDepartmentList", { merchantCode })
        .then(function (response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.departmentOptions = response.data.data;
          }
        });
    },

    // 导入会员
    handlePreview(file) {
      console.log("点击文件列表中已上传的文件======>", file);
    },
    handleRemove(file, fileList) {
      console.log("文件列表移除文件====>", file);
    },
    handleExceed(file, fileList) {
      this.$message.warning("当前限制上传1个文件");
    },

    async handleSuccess(file, fileList) {
      var that = this;
      console.log("上传的======》", file);
      let url = file.data.url;
      if (url) {
        let data = {};
        data.url = url;
        data.loginName = localStorage.getItem("loginName");
        that.$http.post("/merchantMembers/uploadXls", data).then((res) => {
          if (res.data.code == 200) {
            that.fileList = [];
            // let url = res.data;
            // this.downLoad(url);
            // this.handleRemove(file,fileList);
            that.$message.success("导入成功");

            that.getListData();
          }
        });
      }
    },
    openImport() {
      this.dialogImport = true;
      this.importFileList = [];
    },

    // downLoad (url) {
    //   debugger
    //     const link = document.createElement('a')
    //         //_blank表示在新窗口打开链接
    //         link.target = '_blank'
    //         link.href = url
    //         link.setAttribute('download', '文件名字' + Date.now() + '.xlsx') // 下载文件的名称及文件类型后缀
    //         document.body.appendChild(link)
    //         link.click()
    //         document.body.removeChild(link) // 下载完成移除元素
    // },
  },
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
.mainInfo{
  margin-top: 16px;
  color: #656565;
  font-size: 14px;
  .titleInfo{
    color: #000;
    font-size: 14px;
    padding-left: 10px;
    position: relative;
  }
  .titleInfo::before{
    position: absolute;
    display: block;
    content: "";
    width: 4px;
    height: 16px;
    background-color: #f59a23;
    left: 0;
    top: 2px;
  }
  .itemInfo{
    display: flex;
    flex-wrap: wrap;
    margin-top: 12px;
    padding: 12px;
    border: 1px solid #E7E7E7;
    width: fit-content;
    height: fit-content;
    border-radius: 12px;
    .item+.item::before{
      content: "";
      display: block;
      width: 1px;
      height: 100%;
      position: absolute;
      background-color: #E7E7E7;
      top: 0;
    }
    .item{
      position: relative;
      .top{
        display: flex;
        flex-direction: column;
        align-items: center;
        .num{
          margin-top: 6px;
          font-size: 19px;
          color: #0F0F0F;
          font-weight: 500;
        }
      }
      .bottom{
        width: 350px;
        display: flex;
        justify-content: center;
        align-items: center;
        .bottomItem{
          width: 50%;
          display: flex;
          flex-direction: column;
          align-items: center;
          .num{
            font-size: 19px;
            font-weight: 500;
            color: #0F0F0F;
          }
        }
      }
    }
  }
}
</style>
